import actions from './actions';

const initState = {
  isRequestPending: true,
};

export default function requestStatusReducer(_state = initState, action) {
  switch (action.type) {
    case actions.SET_PENDING_TO_TRUE:
      return true;
    case actions.SET_PENDING_TO_FALSE:
      return false;
    default:
      return false;
  }
}
